export enum RecordType {
  PROJECT_STATUS_CHANGE = 'PROJECT STATUS CHANGE',
  RESOURCE_STATUS_CHANGE = 'RESOURCE STATUS CHANGE',
  RESOURCE_ADD = 'REPLAN PROJECT',
  RESOURCE_REMOVE = 'RESOURCE REMOVE',
  INCIDENT_ADD = 'INCIDENT ADD',
  INCIDENT_REMOVE = 'INCIDENT REMOVE'
}
